import {
  TAppGroup,
} from '@/types/app-type.ts';

export const appTileColorMap: Record<TAppGroup, string> = {
  ProductionPlanning: 'var(--color-130)',
  Operations: 'var(--color-120)',
  QualityAssurance: 'var(--color-209)',
  Analytics: 'var(--color-218)',
  MasterData: 'var(--color-189)',
  Administration: 'var(--color-106)',
  Operation: 'var(--color-120)',
  Data: 'var(--color-218)',
  Maintenance: 'var(--color-189)',
  Process: 'var(--color-130)',
  Configuration: 'var(--color-122)',
};
